function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import classnames from "classnames";
import BranchLink from "web/react/components/branch-link/branch-link";
import styles from "./send-to-app.css";
export default function SendToApp(_ref) {
  var _classnames, _classnames2, _classnames3;

  var title = _ref.title,
      productImageURL = _ref.productImageURL,
      analyticsEventLabel = _ref.analyticsEventLabel,
      url = _ref.url,
      downloadCTA = _ref.downloadCTA,
      extraContent = _ref.extraContent,
      className = _ref.className,
      appDeepLinkURL = _ref.appDeepLinkURL,
      financialIncentiveWebviewToken = _ref.financialIncentiveWebviewToken;
  return React.createElement("div", {
    className: classnames(className, styles.content)
  }, React.createElement("h1", {
    className: classnames(styles.title, (_classnames = {}, _defineProperty(_classnames, styles.titleLargerMargin, !extraContent), _defineProperty(_classnames, styles.titleSmallerMargin, extraContent), _classnames))
  }, title), React.createElement("div", {
    className: classnames(styles.imgContainer, (_classnames2 = {}, _defineProperty(_classnames2, styles.imgContainerLargerMargin, !extraContent), _defineProperty(_classnames2, styles.imgContainerSmallerMargin, extraContent), _classnames2))
  }, productImageURL && React.createElement("img", {
    src: productImageURL,
    className: styles.productImg
  }), React.createElement("div", {
    role: "presentation",
    className: classnames(styles.img, (_classnames3 = {}, _defineProperty(_classnames3, styles.smallImg, productImageURL != null), _defineProperty(_classnames3, styles.largeImg, productImageURL == null), _classnames3))
  })), React.createElement(BranchLink, {
    title: downloadCTA,
    className: styles.button,
    branchLink: url,
    eventLabel: analyticsEventLabel,
    appDeepLinkURL: appDeepLinkURL,
    financialIncentiveWebviewToken: financialIncentiveWebviewToken,
    primaryButton: true
  }), extraContent && extraContent());
}